import { Box } from '@chakra-ui/react'
import NumberTicker from '@/components/magicui/number-ticker'

interface AnimatedCounterProps {
  value: number
  prefix?: string
  suffix?: string
  className?: string
  delay?: number
}

export default function AnimatedCounter({
  value,
  prefix,
  suffix,
  className,
  delay = 0,
}: AnimatedCounterProps) {
  return (
    <Box display="inline-flex" alignItems="baseline" gap={0}>
      {prefix && <span className={className}>{prefix}</span>}
      <NumberTicker value={value} delay={delay} className={className} />
      {suffix && <span className={className}>{suffix}</span>}
    </Box>
  )
}
